var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Heartland-ALX",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tablet---720-minimum-Copy",
    transform: "translate(-660.000000, -21.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(660.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#0072CE"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2-Copy",
    cx: 20,
    cy: 20,
    r: 20
  })), /*#__PURE__*/React.createElement("g", {
    id: "user-(2)",
    transform: "translate(11.000000, 9.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99997743,10.8 C11.9711837,10.8 14.4,8.37119382 14.4,5.4 C14.4,2.42880618 11.9711837,0 8.99997743,0 C6.02877119,0 3.6,2.42880618 3.6,5.4 C3.6,8.37119382 6.02881633,10.8 8.99997743,10.8 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9615285,15.4831432 C17.8247192,15.1386911 17.6423504,14.817226 17.4371582,14.5187038 C16.3883739,12.9572202 14.7696598,11.923908 12.9457099,11.6713157 C12.717738,11.6483728 12.4669427,11.6942587 12.2845302,11.8320483 C11.3269522,12.5438953 10.1870053,12.9112903 9.00141166,12.9112903 C7.81581804,12.9112903 6.67587116,12.5438953 5.71829309,11.8320483 C5.53588065,11.6942587 5.28508535,11.6253859 5.05711343,11.6713157 C3.23316352,11.923908 1.59162606,12.9572202 0.565665142,14.5187038 C0.360472958,14.817226 0.178060512,15.161678 0.0412948158,15.4831432 C-0.0270880322,15.6209328 -0.00430829596,15.7816653 0.064074552,15.9194549 C0.246486999,16.2409201 0.474458918,16.5624291 0.679651101,16.8379644 C0.998829244,17.2742762 1.34083076,17.6646141 1.72843539,18.0320091 C2.04761353,18.3534742 2.41239479,18.6519964 2.77721968,18.9505186 C4.57834622,20.3053398 6.74429765,21.0171429 8.97863193,21.0171429 C11.2129662,21.0171429 13.3789176,20.3052958 15.1800442,18.9505186 C15.5448254,18.6749833 15.9096067,18.3534742 16.2288285,18.0320091 C16.5936097,17.6646141 16.958391,17.2742322 17.2776128,16.8379644 C17.5055847,16.5394422 17.7108205,16.2409201 17.8931893,15.9194549 C18.0071316,15.7816653 18.0299114,15.6208888 17.9615285,15.4831432 Z",
    id: "Path"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfile);
export default __webpack_public_path__ + "static/media/default-profile.de6aabb024b8b1f97061d9a58953f30e.svg";
export { ForwardRef as ReactComponent };